module.exports = __webpack_public_path__ + "img/banner_11pick5_sd.f96c0112.jpg";